import { Routes } from '@angular/router';

import { LoginComponent } from '../../pages/login/login.component';
import { ECertComponent } from '../../pages/eCert/e-cert.component';
import { PasswordChangeComponent } from '../../pages/password-change/password-change.component';
import { UpdatePasswordComponent } from '../../pages/update-password/update-password.component';
export const AuthLayoutRoutes: Routes = [
  { path: 'login', component: LoginComponent, title: 'Login - CVT Web' },
  { path: 'activate/:token', component: ECertComponent, title: 'Activate Account - CVT Web' },
  { path: 'eCert', component: ECertComponent, title: 'eCert - CVT Web' },
  { path: 'changepassword/:userId', component: PasswordChangeComponent, title: 'Change Password - CVT Web' },
  { path: 'update-password/:userId', component: UpdatePasswordComponent, title: 'Update Password - CVT Web' }
];
